import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {DatasetType} from '#lit/types/datasets.js';
import type {ClassInfo} from 'lit/directives/class-map.js';
import {classMap} from 'lit/directives/class-map.js';
import {ifDefined} from 'lit/directives/if-defined.js';

export const DATASET_LABEL_ELEMENT_TAG = 'dataset-label';

/**
 * DatasetLabel -- used to render a dataset label based on type.
 */
@customElement(DATASET_LABEL_ELEMENT_TAG)
export default class DatasetLabel extends FlywheelComponent {
  @property()
  type: DatasetType = DatasetType.USER;

  @property()
  name = '';

  @property()
  description?: string;

  static get styles() {
    return [styles];
  }

  get classes(): ClassInfo {
    return {
      'dataset-label': true,
      'dataset-label--primary': this.type === DatasetType.USER,
      'dataset-label--green': this.type === DatasetType.TRANSACTION,
      'dataset-label--secondary': this.type === DatasetType.EVENT,
    };
  }

  render() {
    return html`
      <div class=${classMap(this.classes)} title=${ifDefined(this.description)}>
        ${this.name}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [DATASET_LABEL_ELEMENT_TAG]: DatasetLabel;
  }
}
